/**
 * AutomationRuleRow — one rule in the Rules panel, with enable/edit/delete
 * (SE-5506).
 * @module features/player-kanban/components/molecules/AutomationRuleRow
 */

export { default } from "./AutomationRuleRowContainer";
export type { AutomationRuleRowContainerProps } from "./AutomationRuleRowContainer";
